/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для категории спортивного питания.
   */
  app.CategorySportNutrition = app.View.extend({
    el: '#category-sport-nutrition',
    events: {
      'click .category-more': 'blockClick',
    },

    /**
     * @inheritDoc
     */
    run: function () {
      if (this.$('.contacts-manager_call').length) {
        this.childViews.callMeView = new app.MessageToCallMeFormContactGroupView();
      }
    },
    /**
     * Клик на блоке.
     * @param {Event} e - событие клика по блоку
     */
    blockClick: function (e) {
      if (e.target.nodeName !== 'A') {
        e.stopPropagation();
        var link = $(e.currentTarget).prev();
        if (link.length && link[0].nodeName === 'A') {
          app
            .helpers
            .RedirectHelper
            .locationAssign(link[0].href);
        }

        return false;
      }

      return true;
    },
  });
})(jQuery);

}.call(window));